(() => {
  const carousel = document.querySelector('[data-home-banner-carousel]');
  if (!carousel || carousel.dataset.ready === 'true') return;
  carousel.dataset.ready = 'true';

  const track = carousel.querySelector('[data-home-banner-track]');
  const slides = [...carousel.querySelectorAll('[data-home-banner-slide]')];
  let active = 0;
  let startX = null;

  const show = (index) => {
    active = (index + slides.length) % slides.length;
    track.style.transform = `translateX(-${active * 100}%)`;
    slides.forEach((slide, slideIndex) => {
      const hidden = slideIndex !== active;
      slide.setAttribute('aria-hidden', String(hidden));
      slide.toggleAttribute('inert', hidden);
    });
    carousel.querySelectorAll('[data-home-banner-dot]').forEach((dot, dotIndex) => {
      const selected = dotIndex === active;
      dot.classList.toggle('is-active', selected);
      dot.setAttribute('aria-current', String(selected));
    });
  };

  const advance = (direction) => show(active + direction);

  carousel.addEventListener('click', (event) => {
    const control = event.target.closest('[data-home-banner-prev], [data-home-banner-next], [data-home-banner-dot]');
    if (!control || !carousel.contains(control)) return;

    if (control.matches('[data-home-banner-prev]')) {
      advance(-1);
      return;
    }

    if (control.matches('[data-home-banner-next]')) {
      advance(1);
      return;
    }

    const currentDots = [...carousel.querySelectorAll('[data-home-banner-dot]')];
    const dotIndex = currentDots.indexOf(control);
    if (dotIndex >= 0) show(dotIndex);
  });
  carousel.addEventListener('pointerdown', (event) => { startX = event.clientX; });
  carousel.addEventListener('pointerup', (event) => {
    if (startX === null) return;
    const difference = event.clientX - startX;
    startX = null;
    if (Math.abs(difference) > 45) advance(difference > 0 ? -1 : 1);
  });
  carousel.addEventListener('pointercancel', () => { startX = null; });
  show(0);
})();
